<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;">
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">Planos</v-toolbar-title>
                    <v-spacer/>
                    <v-text-field
                        dense
                        clearable
                        outlined
                        single-line
                        hide-details
                        v-model="search"
                        label="Pesquise.."
                        append-icon="mdi-magnify"
                    ></v-text-field>
                    <v-spacer/>
                    <v-btn color="primary" fab small @click="novo">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card elevation="2" class="ma-1">
                    <v-card-text>
                        <v-data-table
                            fixed-header
                            :headers="headers"
                            :items="dados"
                            sort-by="id"
                            :mobileBreakpoint="0"
                            :loading="loading"
                            :height="$vuetify.breakpoint.height - 180"
                            @click:row="editar"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                            :search="search"
                        >
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <Plano
                    :visible="visible"
                    @close="visible = false"
                />
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer'
import Plano from './Plano'

export default {
    name: 'Planos',

    components: {
        BaseContainer,
        Plano,
    },

    data: () => ({
        empresa: {},
        empresaId: '',
        search: '',
        visible: false,
        loading: false,
        dados: [],
        cobranca: {},
        headers: [
            { text: 'DB', value: 'database' },
            { text: 'Razao Social', value: 'razao_social' },
            { text: 'Whatsapp', value: 'whatsapp' },
            { text: 'Municipio', value: 'municipio' },
            { text: 'UF', value: 'uf' },
        ],
    }),

    mounted() {
        this.consultar();
    },

    methods: {
        consultar() {
            this.loading = true;
            this.dados = [];

            this.$http.get('assinaturas/planos').then(resp => {
                this.dados = resp.data.data;
                this.loading = false;
            })
            .catch(() => {
                alert('Não foi possivel concluir a operação', 'warning');
            }).finally(() => (this.loading = false));
        },

        datetime(dh, format = 'DD/MM/YYYY HH:mm') {
            return dh ? this.moment(dh).format(format) : '';
        },

        novo() {
            window.open(`${this.baseZaperComandas}/register`);
        },

        editar(row) {
            this.$store.commit('setEmpresa', row);
            this.$router.push('/financeiro');
        },
    },
}
</script>
